import styled from 'styled-components';

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 10px;

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 220px;
    height: 40px;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    text-decoration: none;
    color: ${({ theme }) => {
      return theme.colors.white;
    }};
    background-color: ${({ theme }) => {
      return theme.colors.primary;
    }};
    border: none;
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    cursor: pointer;
    transition: filter 200ms ease-in-out;
    &:hover {
      filter: brightness(85%);
    }
  }
`;

export const ButtonFooter = styled.button`
  width: 220px;
  height: 40px;
  padding: 10px;
  font-family: inherit;
  font-size: ${({ theme }) => {
    return theme.fonts.size.normal;
  }};
  font-weight: ${({ theme }) => {
    return theme.fonts.weight.thin;
  }};
  color: ${({ theme }) => {
    return theme.colors.white;
  }};
  background-color: ${(props) => props.color};
  border: none;
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
  cursor: pointer;
  transition: filter 200ms ease-in-out;
  &:hover {
    filter: brightness(85%);
  }
  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme }) => {
      return theme.colors.border;
    }};
  }
`;
